import { render, staticRenderFns } from "./message-record.vue?vue&type=template&id=25660ff4&scoped=true"
import script from "./message-record.vue?vue&type=script&lang=js"
export * from "./message-record.vue?vue&type=script&lang=js"
import style0 from "./message-record.vue?vue&type=style&index=0&id=25660ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25660ff4",
  null
  
)

export default component.exports